import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import {
  fetchVehicleStereoType,
  initializeVehicleStereoTypeScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleStereoType,
  saveVehicleStereoTypeTableState
} from "../../../redux/actions/vehicles/vehicleStereoType";
import VehicleStereoType from '../../../component/Vehicles/VehicleStereoType';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleStereoTypeScreen(props) {
  const {
    fetchVehicleStereoType,
    initVehicleStereoTypeScreen,
    showPageLevelLoader,
    vehicleStereoTypeListview,
    paginationInfo,
    screenPermissions,
    exportVehicleStereoType,
    isVehicleStereoTypeExportError,
    isVehicleStereoTypeExportSuccess,
    isLoading,
    savedTableState,
    saveVehicleStereoTypeTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleStereoTypeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleStereoType(savedParams);
    } else {
      fetchVehicleStereoType({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleStereoType(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleStereoTypeTableState(tableState);
  };
  const handleCreateVehicleStereoType = () => {
    navigate(APP_URLS.VEHICLE_STEREOTYPE.CREATE);
  }
  const editVehicleStereoTypeRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_STEREOTYPE.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleStereoType = {
    handleCreateVehicleStereoType,
    exportVehicleStereoType,
    isVehicleStereoTypeExportError,
    isVehicleStereoTypeExportSuccess,
    editVehicleStereoTypeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchVehicleStereoTypes: loadLazyData,
    tableData: {
      columns: vehicleStereoTypeListview?.columns,
      rows: vehicleStereoTypeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleStereoType
        {...vehicleStereoType}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleStereoTypeScreen: () => dispatch(initializeVehicleStereoTypeScreen()),
    fetchVehicleStereoType: (payload) => dispatch(fetchVehicleStereoType(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleStereoType: (payload) => dispatch(exportVehicleStereoType(payload)),
    saveVehicleStereoTypeTableState: (payload) => dispatch(saveVehicleStereoTypeTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleStereoTypeCreateSuccess: selectFromVehicleStereoTypeReducer(
      state,
      "isVehicleStereoTypeCreateSuccess"
    ),
    vehicleStereoTypeListview: selectFromVehicleStereoTypeReducer(
      state,
      "vehicleStereoTypeListview"
    ),
    showPageLevelLoader: selectFromVehicleStereoTypeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleStereoTypeReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleStereoTypeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleStereoTypeReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleStereoTypeExportError: selectFromVehicleStereoTypeReducer(
      state,
      "isVehicleStereoTypeExportError"
    ),
    isVehicleStereoTypeExportSuccess: selectFromVehicleStereoTypeReducer(
      state,
      "isVehicleStereoTypeExportSuccess"
    ),
    savedTableState: selectFromVehicleStereoTypeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleStereoTypeReducer = (state, path) => {
  return selectVehicleStereoTypeReducer(state)[path];
};

const selectVehicleStereoTypeReducer = ({ vehicleStereoTypeReducer }) => {
  return vehicleStereoTypeReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleStereoTypeScreen);
